import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Dashboard from '../../views/Dashboard/';
import Page404 from '../../views/Pages/Page404/';

// Pedidos Viandas
import FormViandas from '../../views/Viandas/PedidosViandas/FormViandas.js'
import HistorialViandas from '../../views/Viandas/HistorialViandas/HistorialViandas.js'

// Para Pedidos Insumos, Cafeteria, Refrigerio
import { abbreviatedTipoPedido } from '../../views/PedidosProducto/enums.js';
import FormPedidosProducto from '../../views/PedidosProducto/FormPedidosProducto.js';
import HistorialPedidosProducto from '../../views/PedidosProducto/HistorialPedidosProducto.js';

import IdleTimer from 'react-idle-timer';

import auth from '../../auth/auth';

class Full extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idle: false
    }
    this.idleTimer = null;
  }

  onIdle = e => {
    auth.logout();
    this.setState(() => ({
      idle: true
    }));
  }

  render() {
    if (this.state.idle) {
      return <Redirect to="/locked" />
    }

    return (
      <div className="app">
        <IdleTimer
          ref={ref => { this.idlerTimer = ref }}
          element={document}
          onIdle={this.onIdle}
          timeout={2000 * 60 * 30}
        > {/*30 Minutos*/}
          <Header />
          <div className="app-body">
            <Sidebar {...this.props} />
            <main className="main">
              <Container fluid>
                <Switch>
                  <Route path="/dashboard" name="Dashboard" component={Dashboard} />

                  {/* Viandas */}
                  <Route path="/pedidosviandas" name="FormViandas" component={FormViandas} />
                  <Route path="/historialviandas" name="HistorialViandas" component={HistorialViandas} />

                  {/* Insumos */}
                  <Route path="/pedidosinsumos/adjuntar/pedidovianda/:pedidoViandaCodigoVerificacion" name="AdjuntarPedidoInsumoAUnaVianda" render={(props) => (
                    <FormPedidosProducto {...props} tipo_pedido={abbreviatedTipoPedido.insumos} />)}
                  />
                  <Route path="/pedidosinsumos" name="PedidosInsumos" render={(props) => (
                    <FormPedidosProducto {...props} tipo_pedido={abbreviatedTipoPedido.insumos} />)}
                  />
                  <Route path="/historialpedidosinsumos" name="HistorialPedidos" render={(props) => (
                    <HistorialPedidosProducto {...props} tipo_pedido={abbreviatedTipoPedido.insumos} />)}
                  />

                  {/* Cafeteria */}
                  <Route path="/pedidoscafeteria" name="PedidosCafeteria" render={(props) => (
                    <FormPedidosProducto {...props} tipo_pedido={abbreviatedTipoPedido.cafeteria} />)}
                  />
                  <Route path="/historialpedidoscafeteria" name="HistorialPedidosCafeteria" render={(props) => (
                    <HistorialPedidosProducto {...props} tipo_pedido={abbreviatedTipoPedido.cafeteria} />)}
                  />

                  {/* Refrigerios */}
                  <Route path="/pedidosrefrigerios" name="PedidosRefrigerios" render={(props) => (
                    <FormPedidosProducto {...props} tipo_pedido={abbreviatedTipoPedido.refrigerios} />)}
                  />
                  <Route path="/historialpedidosrefrigerio" name="HistorialPedidosRefrigerio" render={(props) => (
                    <HistorialPedidosProducto {...props} tipo_pedido={abbreviatedTipoPedido.refrigerios} />)}
                  />

                  {/* El redirect va con exact: sin eso matchea cualquier ruta y se
                      tragaba las URLs invalidas, mandandolas calladas al dashboard.
                      Ahora solo "/" redirige y el resto cae en el 404. */}
                  <Redirect exact from="/" to="/dashboard" />
                  <Route name="Page 404" component={Page404} />
                </Switch>
              </Container>
            </main>
          </div>
          {/* <ShortcutsBar /> */}
        </IdleTimer>
      </div>
    );
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js